/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoLocalActivityFilter(): angular.IFilterService {
        const filter = (str: any) => {

            if (str == "" || !str) {
                return str;
            }
            if (str.indexOf("[Local Activity]") != -1) {
                var res = str.replace("[Local Activity]", "");
                return res;
            } else {
                return str;

            }

        };
        return filter;
    }


    angular.module("meevo.components.filters")
        .filter("meevoLocalActivity", meevoLocalActivityFilter);
}
